import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";

declare const Android: AndroidInterface;

export class AuthenticationHelper {
  static getAuthHeader(body?: string | null): string {
    if (Android && typeof Android?.generateSignatureHeader === "function") {
      return Android.generateSignatureHeader(body ?? undefined);
    }

    return "";
    // old API key
    // return "apikey Y2xpbnN0dnZZeWwybXhjS0FPdHUxOURMbkM2NFVJNDZUS1I3cnllQlhRd29VTjZ0bFhSWVlCeHRKSmt5RnlidQ==";
  }
}
